import { useCMSPageField } from '@/cms/fields'
import { SummerWeatherGraphColumn } from '@/scopes/content/components/Weather/SummerWeatherGraphColumn'
import { SummerWeatherGraphHeading } from '@/scopes/content/components/Weather/SummerWeatherGraphHeading'
import { WeatherGraph, WeatherGraphHeading } from '@/scopes/content/components/Weather/WeatherGraph'
import { computeTiers } from '@/scopes/content/domain/weather'

export function SummerWeatherGraph() {
  const monthlyWeathers = useCMSPageField('ContentPage.weather') ?? []

  if (monthlyWeathers.length === 0)
    return null

  const highestMaxTemp = Math.max(...monthlyWeathers.map(month => month.maxTemp))

  if (highestMaxTemp === 0)
    return null

  const temperatureTiers = computeTiers(monthlyWeathers)
  const showWaterTemperature = monthlyWeathers.some(month => month.waterTemp != null)
  const showDaysOfRain = monthlyWeathers.some(month => month.daysOfRain != null)

  return (
    <WeatherGraph>
      <WeatherGraphHeading>
        <SummerWeatherGraphHeading showWaterTemperature={showWaterTemperature} showDaysOfRain={showDaysOfRain} />
      </WeatherGraphHeading>
      {monthlyWeathers.map(month => (
        <SummerWeatherGraphColumn
          key={month.month}
          data={month}
          maxTempRatio={month.maxTemp / highestMaxTemp}
          tier={temperatureTiers.get(month.month)!}
          showWaterTemperature={showWaterTemperature}
          showDaysOfRain={showDaysOfRain}
        />
      ))}
    </WeatherGraph>
  )
}
